import CreditCardPaymentProfile from './CreditCardPaymentProfile';

export default CreditCardPaymentProfile;
